import { createLazyComponent, LazyModule } from 'owa-bundling';

// Created lazy module from which components can be loaded on demand.
const unifiedGroupListLazyModule = new LazyModule(
    () => import(/* webpackChunkName: "UnifiedGroupList" */ './unifiedGroupList')
);

// Export component which will load the module when component is mounted. Multiple components can be loaded from the same module.
export default createLazyComponent(unifiedGroupListLazyModule, m => m.default);
